var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel"},[_c('el-carousel',{attrs:{"interval":5000,"arrow":"always"}},_vm._l((4),function(item){return _c('el-carousel-item',{key:item},[_c('h3',[_vm._v(_vm._s(item))])])}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }